import React from 'react';
import './Ticker.css';

const messages = [
  '🚨 ARNAQUE CONFIRMÉE — JumpVendor.com',
  '💳 Prélèvements multiples non autorisés',
  '⚠️ Abonnements cachés sans consentement',
  '🔴 Faux lien TikTok — Redirection frauduleuse',
  '📢 Signalez à la DGCCRF — 0809 540 550',
  '🚨 Site actif — Partagez pour alerter vos proches',
];

export default function Ticker() {
  const text = messages.join('   ·   ');
  return (
    <div className="ticker" role="marquee" aria-label="Alertes actives">
      <div className="ticker__label">🔴 EN DIRECT</div>
      <div className="ticker__track">
        <span className="ticker__content">{text}&nbsp;&nbsp;&nbsp;·&nbsp;&nbsp;&nbsp;{text}</span>
      </div>
    </div>
  );
}
